const getFormattedPriceWithoutDecimals = (value: number) => {
  if (value >= 1000 && value < 1000000) {
    return `£${Math.floor(value / 1000)}k`;
  }
  if (value >= 1000000) {
    return `£${Math.floor(value / 1000000)}m`;
  }
  return `£${value.toFixed(0)}`;
};

export default getFormattedPriceWithoutDecimals;
